import axios from 'axios'
import { Message } from 'ant-design-vue'

let redirectingToSso = false

function redirectToSso () {
  if (redirectingToSso || window.location.hash.indexOf('#/login') === 0) {
    return
  }
  redirectingToSso = true
  const target = (window.location.pathname || '/') +
    (window.location.search || '') + (window.location.hash || '')
  window.location.replace('/admin/oauth/login?next=' + encodeURIComponent(target))
}

// The Flask callback stores the JWT in an HttpOnly cookie and redirects to
// /?sso=1. Remove an old localStorage JWT before the first API request so it
// cannot override the new SSO session.
if (window.location.search.indexOf('sso=1') !== -1) {
  window.localStorage.removeItem('authorization')
  if (window.history && window.history.replaceState) {
    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash)
  }
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // jwt token
    if (window.localStorage['authorization']) {
      config.headers['authorization'] = window.localStorage['authorization']
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.headers['authorization']) {
      window.localStorage['authorization'] = response.headers['authorization']
    }
    return response.data
  },
  /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {
    console.log(error.response)
    if (error.response && error.response.status === 401) {
      // A direct launch from MaxKey may open the Vue route itself, without
      // first visiting /admin/oauth/login. Start the authorization-code flow
      // automatically and preserve the current hash route.
      if (window.location.hash.indexOf('#/login') !== 0) {
        redirectToSso()
        // Do not let individual page handlers push the user to the local
        // login form while the browser is leaving for MaxKey.
        return new Promise(() => {})
      }
      return Promise.reject(error.response)
    }
    let message = ''
    if (error.response && error.response.data) {
      const data = error.response.data
      if (typeof data === 'string') {
        message = data
      } else if (data.errors) {
        data.errors.forEach(element => {
          message += element.defaultMessage + '; '
        })
      } else {
        message = data.message
      }
    } else if (error.message) {
      message = error.message
    } else {
      message = '网络错误'
    }
    Message.error(message, 5)
    return Promise.reject(error.response)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js